import { h } from "preact";

interface ProductReviewProps {
  rating?: number;
  reviews?: number;
}

/**
 * ProductReview - Displays product rating and review count
 * 
 * **Features:**
 * - Shows star icon with SVG
 * - Displays rating and review count
 * - Handles undefined values gracefully
 * 
 * **Display:**
 * - Only renders if both rating and reviews are provided
 * - Star icon with yellow color (#FDB022)
 * - Rating in bold, review count in normal weight
 * 
 * @param rating - Product rating (e.g., 4.5)
 * @param reviews - Number of reviews (e.g., 200)
 * @returns JSX element or null
 */
const ProductReview = ({ rating, reviews }: ProductReviewProps) => {
  if (rating === undefined || reviews === undefined) return null;

  return (
    reviews !== 0 && (
    <div className="flex items-center gap-1.5">
      <div className=" w-3 md:!w-3.5 h-3 md:!h-3.5 relative">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="14"
          height="14"
          viewBox="0 0 14 14"
          fill="none"
        >
          <path
            d="M2.6775 13.6501L3.815 8.7326L0 5.4251L5.04 4.9876L7 0.350098L8.96 4.9876L14 5.4251L10.185 8.7326L11.3225 13.6501L7 11.0426L2.6775 13.6501Z"
            fill="#FDB022"
          />
        </svg>
      </div>
      <div>
        <span className="text-neutral-100 text-xs md:text-sm font-semibold font-inter-tight leading-[18px] pr-1">
          {rating} 
        </span>
        <span className="text-neutral-100 text-xs md:text-sm font-normal font-inter-tight leading-[18px] not-italic">
           ({reviews})
        </span>
      </div>
    </div>
    )
  );
};

export default ProductReview;
